import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { Model } from 'app/model/backendmodel';
import { Owned } from 'app/model/base/named';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { StoreReadSettings } from 'app/model/pipeline/copysource/store-read-settings/store-read-settings';
import { Metamodel } from 'app/model/base/model';
import { merge } from 'lodash';
import { BaseAsyncAdapter, ITridentResource } from 'shell-models-lib';

export const genericStoreReadSettingsAdapts = {
    type: '*'
};

export abstract class StoreReadSettingsAdapter<
    T extends StoreReadSettings,
    U extends Model.StoreReadSettings
> extends BaseAsyncAdapter<T, U> {
    protected override async _toResource(model: T): Promise<U> {
        const settingType = Metamodel.modelOf(model).name;
        const result: Model.StoreReadSettings = {
            type: settingType
        };

        result.maxConcurrentConnections = ValueAdapter.toResource(model, StoreReadSettings.MAXCONCURRENT_CONNECTIONS);

        if (model.raw) {
            const parsed = JSON.parse(model.raw);
            merge(result, parsed);
        }
        return result as U;
    }

    protected override async _toModel(resource: U, copySource: CopySource): Promise<T> {
        const resourceModel = Metamodel.modelByName(resource.type);
        const model = Owned.create<T>(resourceModel, copySource);

        ValueAdapter.toModel(model, StoreReadSettings.MAXCONCURRENT_CONNECTIONS, resource.maxConcurrentConnections);

        const rawObject = {};
        merge(rawObject, await ValueAdapter.remainder(this.context, resource, resourceModel));
        model.raw = JSON.stringify(rawObject);
        return model;
    }

    protected async _toAzureResource(tridentResource: ITridentResource): Promise<U> {
        throw `Artifact type '${tridentResource.artifactType}' does not implement _toAzureResource method.`;
    }
}
